import React, { useState } from 'react';

import { Link } from 'react-router-dom';

import { ChevronDown, Menu, X } from 'lucide-react';

import SearchBar from './SearchBar';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);

  return (
    <nav className="bg-[#003366] text-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <span className="ml-2 text-xl font-bold">SOL IN PRIME JC</span>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-[#EAEAEA] hover:text-white">
              Inicio
            </Link>

            <Link to="/servicios" className="text-[#EAEAEA] hover:text-white">
              Servicios
            </Link>

            <Link to="/planes" className="text-[#EAEAEA] hover:text-white">
              Planes
            </Link>

            <div className="relative group">
              <button
                className="flex items-center text-[#EAEAEA] hover:text-white"
                onClick={() => setIsResourcesOpen(!isResourcesOpen)}
              >
                Recursos
                <ChevronDown className="ml-1 h-4 w-4" />
              </button>
              <div
                className={`absolute z-50 left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 ${isResourcesOpen ? '' : 'hidden'}`}
              >
                <div className="py-1">
                  <Link
                    to="/blog"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setIsResourcesOpen(false)}
                  >
                    Blog
                  </Link>
                  <Link
                    to="/casos-de-exito"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setIsResourcesOpen(false)}
                  >
                    Casos de Éxito
                  </Link>
                </div>
              </div>
            </div>

            <Link to="/nosotros" className="text-[#EAEAEA] hover:text-white">
              Nosotros
            </Link>
            <Link to="/contacto" className="text-[#EAEAEA] hover:text-white">
              Contacto
            </Link>
            <SearchBar />
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-[#EAEAEA] hover:text-white focus:outline-none"
            >
              {isOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden ${isOpen ? 'block' : 'hidden'}`}>
        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-[#003366]">
          <Link
            to="/"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Inicio
          </Link>
          <Link
            to="/servicios"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Servicios
          </Link>
          <Link
            to="/planes"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Planes
          </Link>
          <Link
            to="/blog"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Blog
          </Link>
          <Link
            to="/casos-de-exito"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Casos de Éxito
          </Link>
          <Link
            to="/nosotros"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Nosotros
          </Link>
          <Link
            to="/contacto"
            className="block px-3 py-2 text-[#EAEAEA] hover:text-white"
            onClick={() => setIsOpen(false)}
          >
            Contacto
          </Link>
          <div className="px-3 py-2">
            <SearchBar />
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
